
import { Component, Vue } from 'vue-property-decorator';
import ShiftTypeRepository from '@/services/Calendar/ShiftType';
import { WPXFormValue } from '@/components/templates/WPXForm';
import { ShiftTypeInterface } from '@/services/Calendar/ShiftType/Interfaces';
import { EditShiftTypeForm } from '@/services/Calendar/ShiftType/forms/EditShiftTypeForm';

@Component({
  inject: [
    'shiftTypeRepository',
  ],
  computed: {
    swatchTextColorStyle(): unknown {
      return {
        // @ts-ignore
        backgroundColor: this.form.data.textColor,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        border: '1px solid black',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
    swatchBackgroundStyle(): unknown {
      return {
        // @ts-ignore
        backgroundColor: this.form.data.background,
        cursor: 'pointer',
        height: '30px',
        width: '30px',
        border: '1px solid black',
        transition: 'border-radius 200ms ease-in-out',
      }
    },
  },
})
export default class EditShiftType extends Vue {
  private readonly shiftTypeRepository!: ShiftTypeRepository;

  private loading: boolean = true;
  private startAtMenu: boolean = false;
  private endAtMenu: boolean = false;
  private breakDuration: Array<{ value: number, text: string }> = [{
    value: 30,
    text: 'Half hour',
  }, {
    value: 60,
    text: 'Hour',
  }];
  private textColorMenu: boolean = false;
  private backgroundMenu: boolean = false;
  private dayType: Array<{ value: string, text: string }> = [{
    value: 'work',
    text: 'Normal Work Day',
  }, {
    value: 'paid',
    text: 'Paid leave',
  }, {
    value: 'unpaid',
    text: 'Unpaid leave',
  }, {
    value: 'sick',
    text: 'Sick leave',
  }, {
    value: 'additional_paid',
    text: 'Additional company paid leave',
  }, {
    value: 'marriage',
    text: 'Leave for marriage',
  }, {
    value: 'blood_donation',
    text: 'Leave for blood donation',
  }, {
    value: 'funeral',
    text: 'Leave for funeral',
  }, {
    value: 'paternity',
    text: 'Paternity leave',
  }, {
    value: 'other',
    text: 'Other',
  }];

  private shiftType: Partial<ShiftTypeInterface> = {};
  private form: WPXFormValue<EditShiftTypeForm> = new WPXFormValue(EditShiftTypeForm);

  private async created(): Promise<void> {
    if (!this.$route.params.shiftTypeId) {
      await this.$router.push({ name: 'calendar_manage_shifts' });
      this.$notifications.error('Shift Type ID not provided.');

      return;
    }

    try {
      this.shiftType = await this.shiftTypeRepository.getShiftType(this.$route.params.shiftTypeId);
      this.form.data.name = String(this.shiftType.name);
      this.form.data.shortName = String(this.shiftType.shortName);
      this.form.data.duration = Number(this.shiftType.duration);
      this.form.data.breakDuration = Number(this.shiftType.breakDuration);
      this.form.data.startAt = String(this.shiftType.startAt).substr(0, 5);
      this.form.data.endAt = String(this.shiftType.endAt).substr(0, 5);
      this.form.data.textColor = String(this.shiftType.textColor);
      this.form.data.background = String(this.shiftType.background);
      this.form.data.dayType = String(this.shiftType.dayType);
      this.form.data.automations = Boolean(this.shiftType.automations);
    } catch (e) {
      console.error(e);
    }

    this.loading = false;
  }

  private async edit(): Promise<void> {
    try {
      await this.shiftTypeRepository.updateShiftType(
        String(this.shiftType.id),
        {
          name: this.form.data.name,
          shortName: this.form.data.shortName,
          duration: Number(this.form.data.duration),
          breakDuration: Number(this.form.data.breakDuration),
          startAt: this.form.data.startAt,
          endAt: this.form.data.endAt,
          textColor: this.form.data.textColor,
          background: this.form.data.background,
          dayType: this.form.data.dayType,
          automations: this.form.data.automations,
        },
      );

      this.$successDialog.show(`Shift Type '${this.form.data.name}' has been edited.`);
    } catch (err) {
      this.$errorDialog.show(err.response.data.error);
    }
  }

  private calculateShiftDuration(): void {
    this.form.data.duration = this.shiftTypeRepository.calculateShiftDuration(
      this.form.data.startAt,
      this.form.data.endAt,
      this.form.data.breakDuration,
    );
  }
}
